export default "__VITE_ASSET__DoqRn2iN__"